import { createCoreMethod } from '../../utils/createCoreMethod';

export const deleteFromLocalStorage = createCoreMethod(
  'deleteFromLocalStorage',
  async (key: string) => {
    return await figma.clientStorage.deleteAsync(key);
  }
);
